export default "__VITE_ASSET__C3bPz1Ho__"